module.exports = __webpack_public_path__ + "media/images/car_left-3cc02ad4560afe5c6eeb303878ced56a.png";